import { SHOP_DOMAIN } from './constants'
export enum ShopCode {
  FIV = 'FIV',
  SIP = 'SIP',
  SIB = 'SIB',
  SUN = 'SUN',
  SRP = 'SRP',
  LUK = 'LUK',
  CHE = 'CHE'
}

export const getShopCode = (): ShopCode => {
  const domain = SHOP_DOMAIN || ''
  if (domain.includes('sunflowerful')) return ShopCode.FIV
  if (domain.includes('silveryprinting')) return ShopCode.SIP
  if (domain.includes('fiverprints')) return ShopCode.SIB
  if (domain.includes('sunfloweric')) return ShopCode.SUN
  if (domain.includes('pinparadise1')) return ShopCode.SRP
  if (domain.includes('lukaprints')) return ShopCode.LUK
  if (domain.includes('sweetxmasgifts')) return ShopCode.CHE
  return ShopCode.FIV
}

/**
 * Kiểm tra giá trị `store` từ API (string | string[] | "A,B" | rỗng) có khớp shop hiện tại không.
 * Không có store => áp dụng cho mọi shop. So khớp theo shop code (FIV), shop name hoặc domain.
 */
export const isStoreMatched = (store: unknown): boolean => {
  const list = (Array.isArray(store) ? store : [store])
    .flatMap((s) => (typeof s === 'string' ? s.split(',') : []))
    .map((s) => s.trim().toLowerCase())
    .filter(Boolean)
  if (!list.length) return true
  if (list.includes('all') || list.includes('*')) return true

  const code = getShopCode().toLowerCase()
  const name = getShopName().toLowerCase()
  const domain = (SHOP_DOMAIN || '').toLowerCase()
  return list.some((s) => s === code || s === name || (!!domain && domain.includes(s)))
}

export const getShopName =(): string => {
  const shopCode = getShopCode()
  switch (shopCode) {
    case ShopCode.SIP:
      return 'silveryprints'
    case ShopCode.FIV:
      return 'fiverprints'
    case ShopCode.SUN:
      return 'sunflowerly'
    case ShopCode.SIB:
      return 'silverybrand'
    default:
      return 'sunflowerly'
  }
}
